'use es6';

import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFileFilteringErrorMessageKey, getFileFilteringErrorMessageOptions } from '../../utils/i18n';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FileExtensionIsNotSupportedError extends Component {
  renderContent() {
    const {
      fileExtension,
      filter
    } = this.props;
    const reasons = filter.get('reasons');
    if (reasons.has(fileExtension)) {
      return /*#__PURE__*/_jsx("span", {
        children: reasons.get(fileExtension)
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: getFileFilteringErrorMessageKey(filter.get('filterType')),
      options: getFileFilteringErrorMessageOptions(filter.get('extensions')),
      "data-test-id": "file-extension-not-supported"
    });
  }
  render() {
    return /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      as: "div",
      children: this.renderContent()
    });
  }
}

// TODO: reference for TS types when being migrated to TS
// FileExtensionIsNotSupportedError.propTypes = {
//   fileExtension: PropTypes.string.isRequired,
//   filter: PropTypes.instanceOf(ImmutableMap).isRequired,
// };